import { useNavigate } from "react-router";
import { useAtomValue, useSetAtom } from "jotai";
import { isLoginAtom } from "src/atoms/authAtom";
import { showErrorToast } from "src/util/antd.util";
import { useEffect } from "react";
import { isBotRespondingAtom } from "src/atoms/chatAtom";

function ErrorFallback() {
  const navigate = useNavigate();
  const isLogin = useAtomValue(isLoginAtom);
  const isRespondingSetter = useSetAtom(isBotRespondingAtom);
  useEffect(() => {
    showErrorToast(new Error("مشکل در اتصال به سرور"));
    isRespondingSetter(false);
    isLogin ? navigate("/chat", { state: {} }) : navigate("/login");
  }, []);
  return null;
}

export default ErrorFallback;
